exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.custom-file-input ~ .custom-file-label[data-browse][data-v-e1e0e7b0]::after {\n    content: 'Elegir';\n}\n", ""]);
